import React from "react";

import { i18nService } from "services";

interface FormRequiredProps {}

export const FormRequired: React.FC<FormRequiredProps> = () => (
  <span className="form-required">
    <span className="visually-hidden">{i18nService.copy["a11y.required"]}</span>
    *
  </span>
);
